import {useAtom} from 'jotai'

import {packageDetailAtom, packagePaymentListAtom, packagePaymentListPagingAtom} from '../store'

export const usePackageDetail = () => {
  const [detail, detailSet] = useAtom(packageDetailAtom)
  const [paymentList, paymentListSet] = useAtom(packagePaymentListAtom)
  const [paymentListPaging, paymentListPagingSet] = useAtom(packagePaymentListPagingAtom)

  return {
    detail,
    detailSet,
    paymentList,
    paymentListSet,
    paymentListPaging,
    paymentListPagingSet,
  }
}
